<template>
  <div class="w-full mt-5" v-if="element.tags && element.tags.length > 0">
    

                          <ul class="w-full space-y-0 flex gap-2.5 flex-wrap">
                            <li v-for="(tag, tagIndex) in element.tags" :key="tagIndex"
                              class="w-auto min-w-[47%] flex justify-between items-center text-sm rounded-lg border-2 border-black border-solid text-black px-4 py-2 h-10 gap-2.5 font-bold"
                              :style="{ background: getColor(tag.name) }">
                              <span class="w-full block">{{ tag.name }}</span>
                              <span class="cursor-pointer" @click="removeTag(element, tagIndex)">X</span>
                            </li>
                          </ul>
                        </div>
</template>

<script>
  export default {
    props: [
      'element', 'default_tag', 'day_tag', 'shared_letters'
    ],

    components: {},
    name: "large-modal",
    data() {
      return {
      }

    },

    methods: {
      removeTag(element, tagIndex) {
        this.$emit('removeTag', element, tagIndex);
      },
      getColor(tagName) {
        let dColor = '#ffffff';
        // console.log('this.day_tag', this.day_tag)
        if(this.day_tag && this.day_tag.length > 0)
        {
          const index = this.day_tag.findIndex(dayTag => dayTag.name === tagName)
          if (index === -1) return dColor

          // Convert index to alphabet: 0 -> A, 1 -> B, etc.
          const letter = String.fromCharCode(65 + index)
          return this.shared_letters[letter] || dColor
        }
        return dColor;
      },
    },
  };
</script>